var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-chat',
                        view: publicPath + 'sprite.svg#view-icon-chat',
                        viewBox: '0 0 25 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };